import I18nBackend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import i18n from 'i18next';

import { initReactI18next } from 'react-i18next';

//

const preferredLng = localStorage.getItem('i18n-lng');

i18n
  .use(I18nBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    backend: {
      loadPath: `${process.env.PUBLIC_URL}/locales/{{lng}}/{{ns}}.json`,
      queryStringParams: {
        v: '4.22.5',
      },
    },
    defaultNS: 'common',
    fallbackLng: 'en',
    lng: preferredLng,
    interpolation: {
      escapeValue: false,
    },
    load: 'languageOnly',
    ns: 'common',
    react: {
      useSuspense: false,
    },
    supportedLngs: ['en', 'es'],
  });

// Exports
// -------

export default i18n;
